import { get } from 'lodash'

function isPublishedToAGOL(distributionLinks) {

  var foundAGOLlink = false

  if (distributionLinks != null) {
    distributionLinks.map(distributionLink => {
      let uri = get(distributionLink, 'uri', null)
      if (uri.includes('tiles.arcgis.com') || uri.includes('services.arcgis.com')) {
        foundAGOLlink = true
      }
    })
  }


  return foundAGOLlink
}


export {
  isPublishedToAGOL
}
